import { SingleValue } from 'react-select';
import { useEffect, useState } from 'react';
import { MultiLineData } from '../../types/global';
import MultiLineGraph from '../home/graphMultiLine';
import Dropdown from '../form-inputs/inputDropdown';
import { graphColourMap } from '../../utils/graphColours';
import PostBenefitGraphData from '../../services/adapters/benefitGraph';
import useRequestState from '../../hooks/useRequestState';
import { OptionType } from '../../types/forms.type';

 interface BenefitGraphRequestProps {
  readonly options: OptionType[];
  readonly liftDataId: string;
  readonly wardName: string;
}

export default function BenefitGraph({
  options, liftDataId, wardName,
}: BenefitGraphRequestProps) {
  const [dropdownStates, setdropdownStates] = useState({ benefitCard: '' });
  const {
    data: graphData,
    handleRequest,
    FallbackWrapper,
  } = useRequestState<Array<MultiLineData>>();

  // treat the selection as unset once it falls out of the current options list, rather than syncing it via an effect
  const isSelectionValid = options.some((option) => option.value === dropdownStates.benefitCard);
  const selectedBenefitCard = isSelectionValid ? dropdownStates.benefitCard : '';

  const getData = async () => {
    if (selectedBenefitCard === '') return;
    const graphAdapter = new PostBenefitGraphData();
    const response = graphAdapter.adaptResponse({ liftDataId, wardName, benefitCardName: selectedBenefitCard });
    await handleRequest(response);
  }; // Removed the incorrect dependency array and comma

  useEffect(() => {
    void getData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBenefitCard]);

  const line = graphData ? graphData.map((series) => series.name) : [];
  const renderGraph = () => {
    if (graphData && selectedBenefitCard !== '') {
      return <MultiLineGraph graphData={graphData} gradient showCategoricalAxis showValueAxis={false} />;
    }
    return <span className="text-secondary">Please select from the dropdown to view the graph.</span>;
  };

  const getGraphHeadline = () => {
    if (line.length === 2) {
      return (
        <>
          <span className="text-secondary text-base">Number of households </span>
          <span style={{ color: graphColourMap[line[0] as keyof typeof graphColourMap] }}>{line[0]}</span>

          <span className="text-secondary"> and </span>
          <span style={{ color: graphColourMap[line[1] as keyof typeof graphColourMap] }}>{line[1]}</span>
        </>
      );
    }
    return (
      <>
        <span className="text-secondary">Number of households </span>
        <span style={{ color: graphColourMap[line[0] as keyof typeof graphColourMap] }}>{line[0]}</span>
      </>
    );
  };
  const handleChange = (dropdownId: string, value: SingleValue<OptionType>) => {
    const selectedValue = value ? value.value : '';
    setdropdownStates((previous) => ({ ...previous, [dropdownId]: selectedValue }));
  };
  return (
    <div className="inline-flex flex-col justify-start card">
      <div id="benefit-graph-header" className="m-2 p-2 self-stretch inline-flex justify-between items-center">
        <div className="inline-flex flex-col justify-center items-start gap-3.5">
          <div className="justify-start text-gray-900 text-sm">Benefit changes</div>
          <div id="benefit-graph-description" className="justify-start">
            {selectedBenefitCard === '' ? null : getGraphHeadline()}
          </div>
        </div>
        <Dropdown
          id="benefitCard"
          label=""
          placement="bottom"
          onChange={handleChange}
          selected={selectedBenefitCard}
          options={options}
        />
      </div>
      <div className="h-48 flex justify-center items-center">
        <FallbackWrapper loadingMessage="Loading graph data...">
          {renderGraph()}
        </FallbackWrapper>
      </div>
    </div>

  );
}
